var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50009 3.99999L1.05815 4.44193L0.616211 3.99999L1.05815 3.55804L1.50009 3.99999ZM4.62509 11.5C4.27992 11.5 4.00009 11.2202 4.00009 10.875C4.00009 10.5298 4.27992 10.25 4.62509 10.25V11.5ZM4.18315 7.56692L1.05815 4.44193L1.94204 3.55804L5.06704 6.68305L4.18315 7.56692ZM1.05815 3.55804L4.18315 0.433044L5.06704 1.31693L1.94204 4.44193L1.05815 3.55804ZM1.50009 3.37499H8.06259V4.62499H1.50009V3.37499ZM8.06259 11.5H4.62509V10.25H8.06259V11.5ZM12.1251 7.43749C12.1251 9.68111 10.3062 11.5 8.06259 11.5V10.25C9.6159 10.25 10.8751 8.9908 10.8751 7.43749H12.1251ZM8.06259 3.37499C10.3063 3.37499 12.1251 5.19383 12.1251 7.43749H10.8751C10.8751 5.88417 9.6159 4.62499 8.06259 4.62499V3.37499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.f3343d8b48c1138be3f9ec11a1cf6f27.svg";
export { ForwardRef as ReactComponent };